import React, { FC } from 'react';
import { useI18n } from '../../context/I18nContext';
import Images from '../../../assets/images';
import Slide from './Slide';

const Slide2: FC = () => {
  const { I18n } = useI18n();

  return (
    <Slide
      title={I18n.t('intro.step2Title')}
      description={I18n.t('intro.step2Description')}
      image={Images.imageSlide2}
    />
  );
};

export default Slide2;
